<template>
	<div id="app">
		<div class="main">
			<div v-if="$route.meta.isMember">
				<MemberHeader />
				<!-- <router-view /> -->
				<router-view v-if="isRouterAlive"></router-view>
			</div>
			<div v-else>
				<Header />
				<Nav v-if="$route.meta.keepAlive" ref="indexTab" />
				<router-view class="wrap main_wrap" />
				<Footer />
			</div>
		</div>
	</div>
</template>

<script>
import Header from '@/components/Header';
import Nav from '@/components/Nav';
import Footer from '@/components/Footer';
import MemberHeader from '@/components/MemberHeader';
import Store from '../store/index.js';

export default {
	components: { Header, Nav, Footer, MemberHeader },
	name: 'app',
	provide() {
		return {
			reload: this.reload
		};
	},
	data() {
		return {
			isRouterAlive: true
		};
	},
	watch: {
		//监听路由跳转滚动条未知初始化
		$route: function(to, from) {
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
		}
	},
	mounted() {
		if (!!window.ActiveXObject || 'ActiveXObject' in window) {
			//判断是否是IE浏览器
			this.$message('请尽量避免使用IE浏览器或360极速浏览器的兼容模式浏览该网站，建议使用谷歌等其他浏览器');
		}
	},
	methods: {
		reload() {
			this.isRouterAlive = false;
			this.$nextTick(function() {
				this.isRouterAlive = true;
			});
		}
	}
};
</script>

<style lang="scss">
#app {
	background: #fafafa;
	width: 100%;
	min-width: 1280px;
	background-size: cover;
	font-size: 14px;
	color: #333333;
	font-family: 'Microsoft YaHei';
	overflow: auto;
	.main {
		width: 100%;
		height: 100%;
		.content {
			position: relative;
		}
	}
}
</style>
